import { combineReducers } from "redux";
import Auth from "./Auth";
import Theme from "./Theme";
import userReducer from "./AppReducers";
import DetailCourse from "./DetailCourse";
import employeeSelectedReducer from "./EmployeeSelections";
import unSelectedReducer from "./UnSelectEmployee";
import checklistReducer from "./ChecklistsReducers";
import LearnerPathReducers from "./LearnerPathReducers";
import PodcastReducers from "./PodCastReducers";

const reducers = combineReducers({
  theme: Theme,
  auth: Auth,
  addcourse: userReducer,
  sCourse: DetailCourse,
  selection: employeeSelectedReducer,
  unselect: unSelectedReducer,
  checklist: checklistReducer,
  learnerPathInfo: LearnerPathReducers,
  podCastInfo: PodcastReducers,
});

export default reducers;
